import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import CustomerListRow from "@/components/admin/CustomerListRow.vue";
import { inject, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { CustomerServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerListView',
    setup(__props) {
        const customers = reactive([]);
        let customerLookup = new Map();
        const search = ref('');
        const router = useRouter();
        const customerService = inject(CustomerServiceSymbol);
        onMounted(() => {
            customerService?.getAllCustomers(customersLoaded);
        });
        function customersLoaded(response) {
            response.forEach(customer => {
                customers.push(customer);
                customerLookup.set(customer.id, customer);
            });
        }
        function rowClick(clickedCustomer) {
            router.push({ name: 'admin-customers-edit', params: { id: clickedCustomer.id.toString() } });
        }
        function filterName(value, query) {
            if (!value || query == null)
                return false;
            const completeCustomer = customerLookup.get(value.id);
            if (!completeCustomer)
                return true;
            let name = completeCustomer.firstname + ' ' + completeCustomer.lastname;
            return name.indexOf(query) > -1;
        }
        function filterAddress(value, query) {
            if (!value || query == null)
                return false;
            const completeCustomer = customerLookup.get(value.id);
            if (!completeCustomer)
                return true;
            let address = completeCustomer.street + ' ' + completeCustomer.unitNumber + ' ' + completeCustomer.postcode + ' ' + completeCustomer.city;
            return address.indexOf(query) > -1;
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: "d-flex flex-wrap ma-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "d-flex"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-h4 text-start pa-0 ma-0" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode(" Kundenverwaltung ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "ma-0 pa-0 d-flex justify-end" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                "data-cy": "search",
                                                modelValue: search.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                                label: "Suche",
                                                class: "v-col-6 pa-0 pr-4",
                                                density: "compact"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.push('/admin/customers/new')))
                                            }, {
                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                    _createTextVNode("Neuen Kunden anlegen")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "pt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                        "data-cy": "customerList",
                                        "items-per-page": 100,
                                        items: customers,
                                        search: search.value,
                                        "custom-key-filter": { 'name': filterName, 'address': filterAddress },
                                        "filter-mode": "some",
                                        headers: [
                                            {
                                                title: 'ID',
                                                align: 'start',
                                                sortable: true,
                                                key: 'id',
                                            },
                                            {
                                                title: 'Name',
                                                align: 'start',
                                                sortable: true,
                                                key: 'name',
                                            },
                                            {
                                                title: 'Addresse',
                                                align: 'start',
                                                sortable: true,
                                                key: 'address',
                                            },
                                            {
                                                title: 'Email',
                                                align: 'start',
                                                sortable: true,
                                                key: 'email'
                                            }
                                        ]
                                    }, {
                                        item: _withCtx(({ item }) => [
                                            _createVNode(CustomerListRow, {
                                                class: "cursor-pointer",
                                                customer: item,
                                                onClick: ($event) => (rowClick(item))
                                            }, null, 8, ["customer", "onClick"])
                                        ]),
                                        _: 1
                                    }, 8, ["items", "search", "custom-key-filter"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
